// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"13cd93cd","885":"f1419ea3"}[chunkId] + ".chunk.js";
};